<template>
 <d-row>
      <d-col lg="8">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span> 
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Simpan</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>

                <!-- Username -->
                <d-col md="6" :class="{ 'form-group--error' : $v.username.$error }">
                  <label for="feUsername">Username ( alamat Email )</label>
                  <d-form-input type="text" id="username" placeholder="Username" v-model.trim="$v.username.$model" />
                  <div  class="verror" v-if="!loading && ( !$v.username.required || !$v.username.email )">Harap isi kolom ini dengan alamat email</div>
                </d-col>

                <!-- Password -->
                <d-col md="6" :class="{ 'form-group--error' : $v.password.$error }">
                  <label for="feUsername">Password</label>
                  <d-form-input type="text" id="password" placeholder="Password" v-model.trim="$v.password.$model" />
                  <div  class="verror" v-if="!loading && !$v.password.required">Harap isi kolom ini</div>
                </d-col>
              </d-form-row>
              <d-form-row>
                <!-- Fullname -->
                <d-col md="6" :class="{ 'form-group--error' : $v.fullname.$error }">
                  <label for="feUsername">Nama Lengkap</label>
                  <d-form-input type="text" id="fullname" placeholder="Nama Lengkap" v-model.trim="$v.fullname.$model" />
                  <div  class="verror" v-if="!loading && !$v.fullname.required">Harap isi kolom ini</div>
                </d-col>
              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import env from '../../env.vue';
import { required, email } from 'vuelidate/lib/validators';

export default {
  components: {
    VueElementLoading,
  },
  name: 'user-info',
  data(){
    return {
      form:'',
      id:'',
      password:'',
      username:'',
      fullname:'',
      loading:false,
      old_data:[],
      error_msg:'',
      show_alert:false,
    }
  },
  validations:{
    username:{ required, email },
    fullname:{ required },
    password:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
  },
  methods: {
    save_form(){
        let dthis=this;        
        let submit=true;
        if (this.$v.$invalid || this.id>0) return;
        if (submit){
          this.loading=true;
          this.axios.post( env.server+'/auth/register',
          {
            username:this.username,
            email:this.username,
            password:this.password,
            fullname:this.fullname,
            active:true
          }).then( resp=>{
            this.loading=false;
            this.id=1;
            this.$buefy.toast.open({ message:'Data saved',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            if (e.response.status==500||e.response.status==400)
              this.pop_alert(JSON.parse(e.response.data).message);
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=10;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      password:'',
      username:'',
      }
      Object.keys(this.old_data).forEach( key=>{
        eval('dthis.'+key+'=\'\'');
      });        
    }
  },
  mounted(){
    this.id=this.$route.query.id;
    if ( this.id>0 ){
      this.loading=true;
      this.axios.get( env.server+'/user/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.password=resp.data.password;
          this.username=resp.data.username;
          this.fullname=resp.data.fullname;
          this.loading=false;
          }
      )
    } else {
      this.resetForm()
    }
  },
};
</script>
